import Bugsnag from '../plugins/bugsnag'
import { isFromLiliApp, hash } from './UtilService'

const isDevMode = process.env.NODE_ENV !== 'production'
const isLocalEnv = window.location.origin.includes('localhost')
const isActive = {
  bugsnag: !isLocalEnv
}
const _getGtmPropList = () => {
  return [
    'ga4_event_name',
    'is_referral',
    'code_referral',
    'IsFromLiliApp',
    'event_category',
    'event_action',
    'event_label',
    'plan',
    'profession',
    'state',
    'kyc_status',
    'screen_order',
    'status',
    'customer_external_id',
    'user_hashed_email',
    'user_hashed_phone_number',
    'user_email',
    'user_phone',
    'main_source_of_income',
    'kyb_docs_type'
  ]
}

export const dataLayerHandler = (
  self,
  eventLabel,
  ga4EventName,
  kycStatus = '',
  eventAction = ''
) => {
  // get Current onboarding step
  let currStep = self.$store.getters['onboarding/data'].currStep
  // Get customer Data Model
  let customerData = self.$store.getters['customer/data']
  // Get errors model
  let fieldErrors = self.$store.getters['errors/fieldErrors']
  // Get list of all the required data layer props (Provided by marketing team)
  // more info at https://docs.google.com/spreadsheets/d/1y2tnn5nwGaRDFXnoGYosJAX0a0aRE9uFUgfOWx-u4mk/edit#gid=1273866678
  const gtmPropList = _getGtmPropList()
  // Iterate over each Prop and handle flow
  let propsData = {
    gtmPropList,
    customerData,
    eventLabel,
    currStep,
    ga4EventName,
    fieldErrors,
    kycStatus,
    eventAction,
    self
  }
  _gtmPropsIterator(propsData)
}

const _gtmPropsIterator = async propsData => {
  for (let prop of propsData.gtmPropList) {
    // Validate prop before push
    handlePropExists(prop)
    // Add prop key value to propsData
    propsData.propertyName = prop
    // Generate the dataLayer item (Object) with the prop as the key
    let propToPush = await _generateDataLayerPropertyObject(propsData)
    // push the new item to the global data layer array (Will push if prop is valid value only)
    propToPush && window.dataLayer.push(propToPush)
  }
  // Triger GTM event
  propsData.self.$gtm.trackEvent({
    event: 'GTM event to GA'
  })
}

const handlePropExists = propName => {
  // Check if there is dataLayer item (object) that contains the provided prop as key, if so remove it to avoid duplicates
  window.dataLayer.forEach((dlProp, idx) => {
    if (typeof dlProp !== 'object') {

    } else if (propName in dlProp) {
      window.dataLayer.splice(idx, 1)
    }
  })
}

async function _generateDataLayerPropertyObject (propsData) {
  switch (propsData.propertyName) {
    case 'ga4_event_name':
      return { ga4_event_name: propsData.ga4EventName }

    case 'main_source_of_income':
      return {
        main_source_of_income: propsData.customerData.incomeType || 'unknown'
      }

    case 'kyb_docs_type':
      return {
        kyb_docs_type: propsData.customerData.kybData ? propsData.customerData.kybData.requiredDocs : ''
      }

    case 'user_email':
      return { user_email: propsData.customerData.email }

    case 'user_phone':
      let formattedNumber = propsData.customerData.phoneNumber
      let originalNumber =
        formattedNumber.substr(1, 3) +
        formattedNumber.substr(6, 3) +
        formattedNumber.substr(10, 4)
      return { user_phone: originalNumber }

    case 'user_hashed_email':
      let hEmail = await hash(propsData.customerData.email)
      return { user_hashed_email: hEmail || '' }

    case 'user_hashed_phone_number':
      let maskedNumber = propsData.customerData.phoneNumber
      let rawNumber =
        maskedNumber.substr(1, 3) +
        maskedNumber.substr(6, 3) +
        maskedNumber.substr(10, 4)
      let hPhoneNumber = await hash(rawNumber)
      return { user_hashed_phone_number: hPhoneNumber || '' }

    case 'is_referral':
      return {
        is_referral: propsData.customerData.referralCode ? 'true' : 'false'
      }

    case 'code_referral':
      return { code_referral: propsData.customerData.referralCode }

    case 'IsFromLiliApp':
      return { IsFromLiliApp: JSON.stringify(isFromLiliApp()) }

    case 'event_category':
      return { event_category: 'onboarding' }

    case 'event_action':
      return { event_action: propsData.eventAction || 'screen load' }

    case 'event_label':
      return { event_label: propsData.eventLabel }

    case 'plan':
      let plan = propsData.customerData.profile
      return { plan }

    case 'profession':
      return { profession: propsData.customerData.segment || 'unknown' }

    case 'state':
      return { state: propsData.customerData.state || 'unknown' }

    case 'kyc_status':
      return { kyc_status: propsData.kycStatus || 'success' }

    case 'screen_order':
      return { screen_order: propsData.currStep }

    case 'status':
      return {
        status: _validateFieldErrors(propsData.fieldErrors) || 'success'
      }

    case 'customer_external_id':
      return { customer_external_id: propsData.customerData.customerId }

    default:
      return false
  }
}

const _validateFieldErrors = fieldErrosMap => {
  let status = ''
  for (let field in fieldErrosMap) {
    if (fieldErrosMap[field]) {
      status = fieldErrosMap[field]
    }
  }
  return status
}

export const bugSnag = (method, payload, key = null) => {
  if (!isActive.bugsnag) return
  try {
    switch (method) {
      case 'notify':
        Bugsnag.notify(payload)
        break

      case 'insertKey':
        Bugsnag[key] = payload
        break

      default:
        break
    }
  } catch (err) {
    isDevMode && console.error(err)
  }
}

export const printLiliHeaders = (url, logId) => {
  console.error(`URL call ${url} server request # is ${logId}`)
}



// WEBPACK FOOTER //
// ./src/services/analyticsService.js